import { IconButton, Stack, Typography } from "@mui/material";
import useReservationStore from "../../stores/useReservationStore";
import index from "../../api/auth/reservations";
import { useEffect, useState } from "react";
import WushSortableTable from "../../components/layout/WushSortableTable";
import { Search } from "@mui/icons-material";
import { addDays, format } from "date-fns";
import { useNavigate, useSearchParams } from "react-router-dom";
import ReservationDateRange from "../../components/text/ReservationDateRange";
import WushTextField from "../../components/form/WushTextField";
import ItemCategoryName from "../../components/text/ItemCategoryName";

export default function Reservations() {
  const [searchParams, setSearchParams] = useSearchParams();

  const { reservations, setReservations } = useReservationStore();

  const defaultStartAt = searchParams.get('startAt') ? addDays(new Date(searchParams.get('startAt')), 1) : new Date();
  const defaultEndAt = searchParams.get('endAt') ? addDays(new Date(searchParams.get('endAt')), 1) : addDays(defaultStartAt, 7);

  const [startAt, setStartAt] = useState(format(defaultStartAt, 'yyyy-MM-dd'));
  const [endAt, setEndAt] = useState(format(defaultEndAt, 'yyyy-MM-dd'));

  const handleSetStartAt = (e) => {
    setStartAt(e.target.value);
    setSearchParams({ startAt: e.target.value, endAt: endAt });
  };

  const handleSetEndAt = (e) => {
    setEndAt(e.target.value);
    setSearchParams({ startAt: startAt, endAt: e.target.value });
  };

  const navigate = useNavigate();

  useEffect(() => {
    index({
      status: ['confirmed', 'paid'],
      sortBy: 'start_at',
      startAt: startAt,
      endAt: endAt,
    }, (response) => {
      setReservations(response);
    });
  }, [startAt, endAt]);

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">Reservations</Typography>
        <Typography variant="body1">Paid for and confirmed reservations</Typography>
      </Stack>
      <Stack direction="row" mb={3} spacing={2} width={{ xs: "100%", sm: "50%" }}>
        <WushTextField type="date" label="Start Date" value={startAt} onChange={handleSetStartAt} />
        <WushTextField type="date" label="End Date" value={endAt} onChange={handleSetEndAt} />
      </Stack>
      <Stack>
        <WushSortableTable
          onRowClick={(row) => navigate(`/reservations/${row.id}`)}
          defaultOrderBy="start_at"
          defaultSortOrder="asc"
          headers={[
            {
              label: "ID",
              key: "id"
            },
            {
              label: "Items",
              customValue: (row) => <Stack direction="column" justifyContent="space-between">
                <ItemCategoryName itemCategory={row.reservation_items[0].item.item_category} clickable />
                <Typography variant="body2">{row.reservation_items[0].quantity}x {row.reservation_items[0].item.name} ({row.bookable_duration.name}) {row.reservation_items.length > 1 && `and ${row.reservation_items.length - 1} other items`}</Typography>
              </Stack>
            },
            {
              label: "Revenue",
              key: "total_price_dollars",
              customValue: (row) => <Typography>${row.total_price_dollars}</Typography>
            },
            {
              label: "Scheduled",
              key: "start_at",
              customValue: (row) => <ReservationDateRange reservation={row} />
            },
            {
              label: "Actions",
              customValue: (row) => (
                <Stack direction="row">
                  <IconButton onClick={() => navigate(`/reservations/${row.id}`)}>
                    <Search />
                  </IconButton>
                </Stack>
              )
            }
          ]}
          data={reservations}
        />
      </Stack>
    </Stack>
  );
}